import { Bedriftsdata } from "codegen";
import { useState } from "react";

import { Direction } from "@ntemarked/mittne-components/dist/Flex/Flex";
import StyledText from "@ntemarked/mittne-components/dist/StyledText/StyledText";

import TextField from "components/organisms/form/TextField";
import { useStrombestillingApiQuery } from "hooks/useStrombestillingApi";
import { SearchButton, SearchMeterWrapper, SearchWrapper } from "pages/Strombestilling/orders/components/MeterSearch";

interface CompanySearchProps {
	company: Bedriftsdata | undefined;
	setCompany: (meter: Bedriftsdata | undefined) => void;
}
export default function CompanySearch({ company, setCompany }: Readonly<CompanySearchProps>) {
	const [orgnr, setOrgnr] = useState<string | null>(null);
	const [searchCompanyMessage, setSearchCompanyMessage] = useState<string | null>(null);

	// Søk
	const { refetch: searchCompany, isFetching: isLoadingCompany } = useStrombestillingApiQuery<Bedriftsdata>(
		`/info/bedrift?orgnr=${orgnr}`,
		[orgnr ?? ""],
		false // Hent bare ved knappetrykk
	);

	async function handleSearch() {
		if (isLoadingCompany) return;
		if (!orgnr || orgnr.length !== 9) {
			setCompany(undefined);
			setSearchCompanyMessage("Orgnummer må være 9 siffer");
			return;
		}
		setSearchCompanyMessage(null);
		setCompany(undefined);

		try {
			const response = await searchCompany();
			if (response.data) {
				setCompany(response.data);
			} else {
				setSearchCompanyMessage("Fant ingen treff på orgnummeret.");
			}
		} catch (error) {
			const errorMessage = error instanceof Error ? error.message : String(error);
			setSearchCompanyMessage(`Noe gikk galt ved søk etter måler, feilmelding: ${errorMessage}`);
		}
	}

	return (
		<SearchWrapper direction={Direction.column} gap="1rem">
			<SearchMeterWrapper>
				<TextField
					label="Orgnummer"
					description="Orgnummer for bedriften"
					type="text"
					autoComplete="off"
					onChange={(e: React.ChangeEvent<HTMLInputElement>) => setOrgnr(e.target.value?.trim())}
					onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
						if (e.key === "Enter") handleSearch();
					}}
				/>
				<SearchButton label={isLoadingCompany ? "Søker..." : "Søk etter bedrift"} type="button" loading={isLoadingCompany} onClick={handleSearch} />
			</SearchMeterWrapper>

			{!!company && <p>Fant selskap {company?.navn}</p>}
			{searchCompanyMessage && <StyledText style={{ fontWeight: "bold" }}>{searchCompanyMessage}</StyledText>}
		</SearchWrapper>
	);
}
